import React, { useEffect, useState } from 'react'
import './_REAuto.scss';
import { useTranslation } from 'react-i18next';
import UiIntegrater from '../../historyRecord/littleUIComponent/UiIntegrater';
import REDropdown from '../REDropdown/REDropdown'
import ApiGo from '../../../../actions/ApiGo';
import { useSelector } from 'react-redux';

const REAuto = (props) => {
    const p = props.data

    // i18n翻譯
    const { t } = useTranslation();

    // 選單內容 vs 要return的data 
    const [turnL_ang, setTurnL_ang] = useState("-") // 00-40
    const [turnL_sty, setTurnL_sty] = useState("-") // 00-60
    const [turnR_ang, setTurnR_ang] = useState("-") // 00-40
    const [turnR_sty, setTurnR_sty] = useState("-") // 00-60
    const [flat_sty, setFlat_sty] = useState("-") // 00-60
    const [total_autotime, setTotal_autotime] = useState("-") // 060-960
    const [weight, setWeight] = useState("-") // 30-120
    const [start_time, setStart_time] = useState("-") // 8,9,10,11PM
    const [end_time, setEnd_time] = useState("-") // 5,6,7,8AM



    // 設定開、關
    const [turnL_angSwitch, setTurnL_angSwitch] = useState()
    const [turnL_stySwitch, setTurnL_stySwitch] = useState()
    const [turnR_angSwitch, setTurnR_angSwitch] = useState()
    const [turnR_stySwitch, setTurnR_stySwitch] = useState()
    const [flat_stySwitch, setFlat_stySwitch] = useState()
    const [total_autotimeSwitch, setTotal_autotimeSwitch] = useState()
    const [weightSwitch, setWeightSwitch] = useState()
    const [start_timeSwitch, setStart_timeSwitch] = useState()
    const [end_timeSwitch, setEnd_timeSwitch] = useState()
    const [long_sty_autotimeSwitch, setLong_sty_autotimeSwitch] = useState()



    const [night_auto_time, setNight_auto_time] = useState(0)
    useEffect(() => {
        setNight_auto_time((24 - start_time + end_time) * 60)
    }, [night_auto_time, start_time, end_time])

    // 開、關的按鈕
    function SwitchFunction(num) {
        switch (num) {
            case 0: setTurnL_angSwitch(!turnL_angSwitch); break;
            case 1: setTurnL_stySwitch(!turnL_stySwitch); break;
            case 2: setTurnR_angSwitch(!turnR_angSwitch); break;
            case 3: setTurnR_stySwitch(!turnR_stySwitch); break;
            case 4: setFlat_stySwitch(!flat_stySwitch); break;
            case 5: setTotal_autotimeSwitch(!total_autotimeSwitch); break;
            case 6: setWeightSwitch(!weightSwitch); break;
            case 7: setStart_timeSwitch(!start_timeSwitch); break;
            case 8: setEnd_timeSwitch(!end_timeSwitch); break;
            case 9: setLong_sty_autotimeSwitch(!long_sty_autotimeSwitch); break;
            default:
                return null;
        }
    }
    // ##### HTML生命週期 ##### 
    const [htmlSwitch, setHtmlSwitch] = useState('day')
    const [initJSON, setInitJSON] = useState({})
    const [long_sty_autoInitJSON, setLong_sty_autoInitJSON] = useState({})
    const [operateJSON, setOperateJSON] = useState({})


    // 因應出貨時程，未來建議 long_stay_autotime 從 mac_alert_setting table 移至 bedAuto_parameter_setting table，變成同一個table裡面取值就好，目前是分成兩個table在取值
    const [lev_over, setLev_over] = useState() // 離床過久 "leaving_overtime": 0, 
    const [leave_from, setLeave_from] = useState() // 離床時段-起 "leaving_overtime_from_time": 0,
    const [leave_end, setLeave_end] = useState() // 離床時段-終  "leaving_overtime_to_time": 0,
    const [long_sty, setLong_sty] = useState() // 久臥警示 "long_stay": 37,
    const [breath_high, setBreath_high] = useState(p !== undefined ? p.breath_high : 0) // 呼吸高於 "breath_high": 30,
    const [breath_low, setBreath_low] = useState(p !== undefined ? p.breath_low : 0) // 呼吸低於 "breath_low": 14,
    const [day_period, setDay_period] = useState() // 日班 alert_level_day
    const [night_period, setNight_period] = useState() // 小夜 alert_level_mid
    const [midnight_period, setMidnight_period] = useState() // 大夜 alert_level_night
    const [long_sty_autotime, setLong_sty_autotime] = useState() // k值連動: 久臥翻身時間

    const mac = p !== undefined ? props.data.mac : "" // 待props傳值

    function GET_AutoTime() {
        ApiGo.getMac_alert_setting(mac)
            .then((fromMac) => {
                try {
                    setLev_over(fromMac.leaving_overtime_day)
                    setLeave_from(fromMac.leaving_overtime_from_time)
                    setLeave_end(fromMac.leaving_overtime_to_time)
                    setLong_sty(fromMac.long_stay_day)
                    setDay_period(fromMac.alert_level_day)
                    setNight_period(fromMac.alert_level_mid)
                    setMidnight_period(fromMac.alert_level_night)
                    // setLong_sty_autotime(parseFloat((fromMac.long_stay_autotime/60).toFixed(2))) // 四捨五入到小數點第二位
                    setLong_sty_autotime(fromMac.long_stay_autotime) // 四捨五入到小數點第二位
                    setLong_sty_autoInitJSON(fromMac.long_stay_autotime)
                } catch { }
            })
    }
    useEffect(() => {
        GET_AutoTime()
    }, [])

    // ##### API GET 取得資料庫最新一組數值 #####
    const id = props.data !== undefined ? props.data.id : 0

    // 取得Beds table的資料
    const store_beds_array = useSelector(state => state.store_beds)
    const [getBedId, setGetBedId] = useState()
    useEffect(() => {
        if (store_beds_array.beds_array != null || undefined) {
            store_beds_array.beds_array.map((bed_arr) => {
                // 與props所傳入的resident_id做比對，若bed table裡的resident_id相同，則取出bed_id
                if (bed_arr.resident_id == id) {
                    setGetBedId(bed_arr.id)
                }
            })
        }
    }, [])


    function API_GET() {
        // ApiGo.getBedAuto_parameter_setting(htmlSwitch, getBedId)
        ApiGo.getBedAuto_parameter_setting(htmlSwitch, id)
            // ApiGo.getBedAuto_parameter_setting("night", 88)
            .then((res) => {
                return htmlSwitch === "day"
                    ? (function () {
                        // 避免點選的受護者並沒有bed_auto_param(沒有分配到pad)的資料
                        try {
                            setTurnL_ang(res.left_turn_angel_day)
                            setTurnL_sty(res.left_turn_time_day)
                            setTurnR_ang(res.right_turn_angel_day)
                            setTurnR_sty(res.right_turn_time_day)
                            setFlat_sty(res.lie_flat_time_day)
                            setTotal_autotime(res.auto_time_day)
                            setWeight(res.weight)
                            // 如果在日間的邏輯中，1. 將最新的資料內容更新到各個欄位之中 2. 並整理成一包資料來比較資料是否有更動才決定是否post
                            setInitJSON({
                                auto_time: res.auto_time_day,
                                right_turn_time: res.right_turn_time_day,
                                left_turn_time: res.left_turn_time_day,
                                lie_flat_time: res.lie_flat_time_day,
                                right_turn_angel: res.right_turn_angel_day,
                                left_turn_angel: res.left_turn_angel_day,
                                weight: res.weight,
                            })
                        } catch { }
                    })()
                    : (function () {
                        try {
                            setTurnL_ang(res.left_turn_angel_night)
                            setTurnL_sty(res.left_turn_time_night)
                            setTurnR_ang(res.right_turn_angel_night)
                            setTurnR_sty(res.right_turn_time_night)
                            setFlat_sty(res.lie_flat_time_night)
                            setTotal_autotime(res.auto_time_night)
                            setWeight(res.weight)
                            setStart_time(res.auto_frequency_start)
                            setEnd_time(res.auto_frequency_end)
                            setInitJSON({
                                auto_time: res.auto_time_day,
                                right_turn_time: res.right_turn_time_day,
                                left_turn_time: res.left_turn_time_day,
                                lie_flat_time: res.lie_flat_time_day,
                                right_turn_angel: res.right_turn_angel_day,
                                left_turn_angel: res.left_turn_angel_day,
                                weight: res.weight,
                                auto_frequency_start: res.auto_frequency_start,
                                auto_frequency_end: res.auto_frequency_end,
                            })
                        } catch { }
                    })()
            })
    }

    useEffect(() => {
        API_GET()
        // },[t, htmlSwitch, getBedId])
        // },[t, htmlSwitch, id])
    }, [t, htmlSwitch, id, getBedId])

    // 負責收集網頁操作的最後結果，整理成一包準備跟初始值做比對
    function COMPARE_JSON() {
        {
            htmlSwitch === "day"
                ? setOperateJSON({
                    auto_time: total_autotime,
                    right_turn_time: turnR_sty,
                    left_turn_time: turnL_sty,
                    lie_flat_time: flat_sty,
                    right_turn_angel: turnR_ang,
                    left_turn_angel: turnL_ang,
                    // long_stay_autotime: long_sty_autotime,
                    weight: weight,
                })
                : setOperateJSON({
                    // auto_time: total_autotime,
                    auto_time: night_auto_time,
                    right_turn_time: turnR_sty,
                    left_turn_time: turnL_sty,
                    lie_flat_time: flat_sty,
                    right_turn_angel: turnR_ang,
                    left_turn_angel: turnL_ang,
                    weight: weight,
                    auto_frequency_start: start_time,
                    auto_frequency_end: end_time,
                })
        }
    }
    useEffect(() => {
        COMPARE_JSON()
        // },[total_autotime, turnR_sty, turnL_sty, flat_sty, turnR_ang, turnL_ang, weight, start_time, end_time])
    }, [total_autotime, night_auto_time, turnR_sty, turnL_sty, flat_sty, turnR_ang, turnL_ang, weight, start_time, end_time])

    // ##### API POST #####
    function API_POST() {
        // 當post資料前，先比對初始的整包資料，是否與之後操作網頁的整包資料有一致，若不同才要post
        // PUT_AutoTime()
        // if (JSON.stringify(initJSON) !== JSON.stringify(operateJSON)){
        if (JSON.stringify(initJSON) !== JSON.stringify(operateJSON) || long_sty_autoInitJSON !== long_sty_autotime) {
            var JSONdataPost = {}
            {
                htmlSwitch === "day"
                    ? JSONdataPost = {
                        bed_id: getBedId,
                        auto_time: total_autotime,
                        right_turn_time: turnR_sty,
                        left_turn_time: turnL_sty,
                        lie_flat_time: flat_sty,
                        right_turn_angel: turnR_ang,
                        left_turn_angel: turnL_ang,
                        long_stay_autotime: long_sty_autotime,
                        // weight: weight,
                        // auto_frequency_day: 0,
                        created_at: (new Date()).Format("yyyy-MM-ddThh:mm:ss.SZ"),
                        updated_at: (new Date()).Format("yyyy-MM-ddThh:mm:ss.SZ")
                    }
                    : JSONdataPost = {
                        bed_id: getBedId,
                        // auto_time: total_autotime,
                        // auto_time: (24-start_time+end_time)*60,
                        auto_time: night_auto_time,
                        right_turn_time: turnR_sty,
                        left_turn_time: turnL_sty,
                        lie_flat_time: flat_sty,
                        right_turn_angel: turnR_ang,
                        left_turn_angel: turnL_ang,
                        // weight: weight,
                        // auto_frequency_night: 0,
                        auto_frequency_start: start_time,
                        auto_frequency_end: end_time,
                        created_at: (new Date()).Format("yyyy-MM-ddThh:mm:ss.SZ"),
                        updated_at: (new Date()).Format("yyyy-MM-ddThh:mm:ss.SZ")
                    }
            }
            ApiGo.postSend_set_auto_param_command(htmlSwitch, JSONdataPost)
                .then((res) => { console.log(`${htmlSwitch} Sent`, res, JSONdataPost) })
                .then(props.hide) // 完成確認後關閉彈出視窗
                .catch((res) => { console.log(`${htmlSwitch} Failed`, res, JSONdataPost) })
        } else {
        }
    }

    // ##### STEP3 : 資料送出回饋機制
    const postSubmit = () => {
        if (htmlSwitch === "day") {
            // 設定result為資料送出前的訊息
            var result = window.confirm(
                `
                ${t("RESIDENTS_SETTING.AUTO.PLEASE_CHECK_FOLLOWING_DATA_SETTINGS")}:\n
                ${t("RESIDENTS_SETTING.AUTO.TURN_LEFT_ANGLE")}:${turnL_ang}${t("GLOBAL.UNIT.DEGREE")}
                ${t("RESIDENTS_SETTING.AUTO.TURN_LEFT_STAY")}:${turnL_sty}${t("GLOBAL.UNIT.MINUTE")}
                ${t("RESIDENTS_SETTING.AUTO.TURN_RIGHT_ANGLE")}:${turnR_ang}${t("GLOBAL.UNIT.DEGREE")}
                ${t("RESIDENTS_SETTING.AUTO.TURN_RIGHT_STAY")}:${turnR_sty}${t("GLOBAL.UNIT.MINUTE")}
                ${t("RESIDENTS_SETTING.AUTO.LIE_FLAT_STAY")}:${flat_sty}${t("GLOBAL.UNIT.MINUTE")}
                ${t("RESIDENTS_SETTING.AUTO.TURN_OVER_TIME")}:${total_autotime}${t("GLOBAL.UNIT.MINUTE")}
                ${t("RESIDENTS_SETTING.SENSOR.AUTO_TIME")}:${long_sty_autotime}${t('GLOBAL.UNIT.MINUTE')}`
            )
            // 當confirm的結果為true(確認)，則呼叫api_put，並且彈出視窗回饋訊息"設定已送出"
            if (result === true) {
                API_POST()
                window.alert(t("RESIDENTS_SETTING.AUTO.DAY_PERIOD_SETTINGS_SENT"))

                // 將自動翻身的部份加上去，因為是用PUT的方式，所以不需要比較就可以PUT，且只有白天需要
                // PUT_AutoTime()
            } else {
                window.alert(t("RESIDENTS_SETTING.AUTO.DAY_PERIOD_SETTINGS_CANCEL"))
            }
        }
        if (htmlSwitch === "night") {
            // 設定result為資料送出前的訊息
            var result = window.confirm(
                `
                ${t("RESIDENTS_SETTING.AUTO.PLEASE_CHECK_FOLLOWING_DATA_SETTINGS")}:\n
                ${t("RESIDENTS_SETTING.AUTO.TURN_LEFT_ANGLE")}:${turnL_ang}${t("GLOBAL.UNIT.DEGREE")}
                ${t("RESIDENTS_SETTING.AUTO.TURN_LEFT_STAY")}:${turnL_sty}${t("GLOBAL.UNIT.MINUTE")}
                ${t("RESIDENTS_SETTING.AUTO.TURN_RIGHT_ANGLE")}:${turnR_ang}${t("GLOBAL.UNIT.DEGREE")}
                ${t("RESIDENTS_SETTING.AUTO.TURN_RIGHT_STAY")}:${turnR_sty}${t("GLOBAL.UNIT.MINUTE")}
                ${t("RESIDENTS_SETTING.AUTO.LIE_FLAT_STAY")}:${flat_sty}${t("GLOBAL.UNIT.MINUTE")}
                ${t("RESIDENTS_SETTING.AUTO.TURN_OVER_TIME")}:${night_auto_time}${t("GLOBAL.UNIT.MINUTE")}
                ${t("RESIDENTS_SETTING.AUTO.TIME_SELECTION")}:${start_time}PM—${end_time}AM`
            )
            // ${t("RESIDENTS_SETTING.AUTO.TURN_OVER_TIME")}:${total_autotime}${t("GLOBAL.UNIT.MINUTE")}
            // ${t("RESIDENTS_SETTING.AUTO.TURN_OVER_TIME")}:${(24-start_time+end_time)*60}${t("GLOBAL.UNIT.MINUTE")}

            // 當confirm的結果為true(確認)，則呼叫api_put，並且彈出視窗回饋訊息"設定已送出"
            if (result === true) {
                API_POST()
                window.alert(t("RESIDENTS_SETTING.AUTO.NIGHT_PERIOD_SETTINGS_SENT"))
            } else {
                window.alert(t("RESIDENTS_SETTING.AUTO.NIGHT_PERIOD_SETTINGS_CANCEL"))
            }
        }
    }

    // 迴圈建立選單範圍 
    const [arrA, setArrA] = useState([])
    const [arrB, setArrB] = useState([])
    const [arrC, setArrC] = useState([])
    const [arrD, setArrD] = useState([])
    const [arrE, setArrE] = useState([])
    const [arrF, setArrF] = useState([])
    const [arrG, setArrG] = useState([])

    // 建立迴圈模組 createArray(起始數值，目標數值，間隔，state，setState)
    // const createArray = (init, final, num, state, setState, format)=>{
    //     if(format === "int"){
    //         for ( let element = init; element <= final ; element += num){
    //             let _array = state
    //             _array.push(element)
    //             setState(_array)
    //         }
    //     }
    //     else{
    //         for ( let element = init; element <= final ; element += num){
    //             let _array = state
    //             _array.push(parseFloat(element).toFixed(1))
    //             _array.push(parseFloat(element).toFixed(1))
    //             setState(_array)
    //         }
    //     }
    // }

    const createArray = (init, final, num, state, setState) => {
        for (let element = init; element <= final; element += num) {
            let _array = state
            _array.push(element)
            setState(_array)
        }
    }
    useEffect(() => {
        createArray(0, 30, 5, arrA, setArrA)
        createArray(0, 60, 5, arrB, setArrB)
        createArray(60, 960, 30, arrC, setArrC)
        createArray(30, 120, 1, arrD, setArrD)
        createArray(20, 24, 1, arrE, setArrE)
        createArray(5, 8, 1, arrF, setArrF)
        // createArray(30,long_sty_autotime,15,arrG,setArrG) // adjust to fix
    }, [])

    useEffect(() => {
        createArray(30, long_sty_autotime, 15, arrG, setArrG)
    }, [long_sty_autotime])

    // ##### AIDC按鈕機制-日間、夜間狀態 #####
    const Day_Html = () => {
        return (
            <>
                <div className="h-10 flied">
                    <div className="fx-ccc w-6 h-75 title_typeA">{t("RESIDENTS_SETTING.AUTO.LIE_FLAT_STAY")}</div>
                    <div className="fx-ccc w-12 h-75 content_input">
                        <div className="dropdown-container">
                            <REDropdown
                                toggleDropdown={SwitchFunction}
                                closeToggle={flat_stySwitch}
                                data={{ "id": 4, "keys": arrB, "data": flat_sty }}
                                returnData={setFlat_sty}
                            />
                        </div>
                        <div className="content-unit">{t("GLOBAL.UNIT.MINUTE")}</div>
                    </div>
                    <div className="fx-ccc w-6 h-75 title_typeA">{t("RESIDENTS_SETTING.AUTO.TURN_OVER_TIME")}</div>
                    <div className="fx-ccc w-12 h-75 content_input">
                        <div className="dropdown-container">
                            <REDropdown
                                toggleDropdown={SwitchFunction}
                                closeToggle={total_autotimeSwitch}
                                data={{ "id": 5, "keys": arrC, "data": total_autotime }}
                                returnData={setTotal_autotime}
                            />
                        </div>
                        <div className="content-unit">{t("GLOBAL.UNIT.MINUTE")}</div>
                    </div>
                </div>
                <div className="h-10 flied"></div>
                <div className="h-10 flied">
                    {/* <div className="fx-ccc w-6 h-75 title_typeA">{t("RESIDENTS_SETTING.SENSOR.AUTO_TIME")}</div> */}
                    <div className="fx-ccc w-6 h-75 title_typeA">日間翻身間隔</div>
                    <div className="fx-ccc w-12 h-75 content_input">
                        <div className="dropdown-container">
                            <REDropdown
                                toggleDropdown={SwitchFunction}
                                closeToggle={long_sty_autotimeSwitch}
                                data={{ "id": 9, "keys": arrG, "data": long_sty_autotime }}
                                returnData={setLong_sty_autotime}
                            />
                        </div>
                        <div className="content-unit">{t('GLOBAL.UNIT.MINUTE')}</div>
                    </div>
                </div>
            </>
        )
    }

    const Night_Html = () => {
        return (
            <>
                <div className="h-10 flied">
                    <div className="fx-ccc w-6 h-75 title_typeA">{t("RESIDENTS_SETTING.AUTO.LIE_FLAT_STAY")}</div>
                    <div className="fx-ccc w-12 h-75 content_input">
                        <div className="dropdown-container">
                            <REDropdown
                                toggleDropdown={SwitchFunction}
                                closeToggle={flat_stySwitch}
                                data={{ "id": 4, "keys": arrB, "data": flat_sty }}
                                returnData={setFlat_sty}
                            />
                        </div>
                        <div className="content-unit">{t("GLOBAL.UNIT.MINUTE")}</div>
                    </div>
                    <div className="fx-ccc w-6 h-75 title_typeA">{t("RESIDENTS_SETTING.AUTO.TURN_OVER_TIME")}</div>
                    <div className="fx-ccc w-12 h-75 content_input">
                        {/* <div className="dropdown-container">
                        <REDropdown 
                            toggleDropdown={SwitchFunction}
                            closeToggle={total_autotimeSwitch}
                            data={{"id":5 , "keys":arrC, "data":total_autotime}}
                            returnData={setTotal_autotime}
                        />
                        </div> */}

                        {/* <div className="content-value">{total_autotime}</div> */}
                        {/* <div className="content-value">{(24-start_time+end_time)*60}</div> */}
                        <div className="content-value">{isNaN(night_auto_time) !== true ? night_auto_time : '-'}</div>
                        <div className="content-unit">{t("GLOBAL.UNIT.MINUTE")}</div>
                    </div>

                </div>
                <div className="h-10 flied"></div>
                <div className="h-10 flied">
                    <div className="fx-ccc w-6 h-75 title_typeA">{t("RESIDENTS_SETTING.AUTO.TIME_SELECTION")}</div>
                    <div className="fx-ccc w-12 h-75 content_input">
                        <div className="dropdown-container">
                            <REDropdown
                                toggleDropdown={SwitchFunction}
                                closeToggle={start_timeSwitch}
                                data={{ "id": 7, "keys": arrE, "data": start_time }}
                                returnData={setStart_time}
                            />
                        </div>
                        <div className="content-unit">PM</div>
                        <div className="markmark"> — </div>
                        <div className="dropdown-container">
                            <REDropdown
                                toggleDropdown={SwitchFunction}
                                closeToggle={end_timeSwitch}
                                data={{ "id": 8, "keys": arrF, "data": end_time }}
                                returnData={setEnd_time}
                            />
                        </div>
                        <div className="content-unit">AM</div>
                    </div>
                </div>
            </>
        )
    }


    // ##### AIDC按鈕機制 #####
    // [set1]當按鈕被按下後，所有按鈕必須要在10秒內關閉功能，不能再次觸發
    // [set2]按下按鈕後，更改指定id的className來觸發，變動後className的動畫效果以及要呈現的文字訊息
    function html_text_set(begin_cls, trigger_cls, txt) {
        document.getElementById(begin_cls).className = trigger_cls
        document.getElementById(begin_cls).innerText = txt
    }

    // [main]按鈕觸發的主程式
    const btns_trigger = (num) => {
        var sec = 10000 // 要delay的秒數*1000
        var array = {
            "type": ["auto", "all_lock", "lie_flat_and_lowest", "lie_flat", "lowest"],
            "msg": [t("RESIDENTS_SETTING.AUTO.AUTO_TURN"), t("RESIDENTS_SETTING.AUTO.PANEL_LOCK"), t("RESIDENTS_SETTING.AUTO.LIE_FLAT_AND_LOWEST"), t("RESIDENTS_SETTING.AUTO.LIE_FLAT"), t("RESIDENTS_SETTING.AUTO.LOWEST"), t("RESIDENTS_SETTING.AUTO.COMMAND_SENDING")],
            "css": ["Before", "After"]
        }

        switch (num) {
            // 如果按鈕觸發後送出 "0"
            case 0:
                // 按下後，指定id的className更動，並觸發動畫及呈現文字的效果
                html_text_set(array["type"][0], array["css"][1], array["msg"][5]) // after
                // 當時間過後又恢復原本設定
                setTimeout(function () {
                    html_text_set(array["type"][0], array["css"][0], array["msg"][0]) //before
                }, sec)
                // 並且送出特定的command指令
                ApiGo.postSend_type_command("auto", getBedId, 1)
                break;
            case 1:
                html_text_set(array["type"][1], array["css"][1], array["msg"][5])
                setTimeout(function () {
                    html_text_set(array["type"][1], array["css"][0], array["msg"][1])
                }, sec)
                ApiGo.postSend_type_command("all_lock", getBedId, 1)
                break;
            case 2:
                html_text_set(array["type"][2], array["css"][1], array["msg"][5])
                setTimeout(function () {
                    html_text_set(array["type"][2], array["css"][0], array["msg"][2])
                }, sec)
                ApiGo.postSend_type_command("lie_flat_and_lowest", getBedId)
                break;
            case 3:
                html_text_set(array["type"][3], array["css"][1], array["msg"][5])
                setTimeout(function () {
                    html_text_set(array["type"][3], array["css"][0], array["msg"][3])
                }, sec)
                ApiGo.postSend_type_command("lie_flat", getBedId)
                break;
            case 4:
                html_text_set(array["type"][4], array["css"][1], array["msg"][5])
                setTimeout(function () {
                    html_text_set(array["type"][4], array["css"][0], array["msg"][4])
                }, sec)
                ApiGo.postSend_type_command("lowest", getBedId)
                break;
            default:
                return null;
        }
        // 但如果觸發按鈕後直接離開畫面，會因為偵測不到id而報錯
        // ButtonDelay(array["type"][0], array["type"][1], array["type"][2], array["type"][3], array["type"][4]) 
        alert(t("RESIDENTS_SETTING.AUTO.COMMAND_SENDING_THANKS"))
    }

    return (
        <>
            {/* 資料過濾區塊 */}
            <UiIntegrater
                OnOff_switch={[false, false, false, true, true]}
                date={new Date()}
                setReturnDate={() => { }}
                name={p !== undefined ? p.last_name : null}
                bed={p !== undefined ? p.first_name : null}
            />
            {/* Personal切版-1 */}
            {/* {HTML_TEMPLATE_A} */}

            {/* Personal切版-2 */}
            <div className="wrap-auto w-100 h-80" style={{ display: 'flex' }}>
                {"我在這理個人資料"}
                <div className="w-100 h-100">
                    <div className="h-10 flied">
                        <div className="fx-ccc w-6 h-75 title_typeC">{t("RESIDENTS_SETTING.AUTO.TURNOVER_SETTING")}</div>
                        {/* 當按下日間/夜間的按鈕後，透過title_typeB_stay反映目前是在日間/夜間設定狀態 */}
                        <div className={`${htmlSwitch === "day" ? "title_typeB_stay" : "title_typeB"} fx-ccc on-mode w-6 h-75`} onClick={() => { setHtmlSwitch('day') }}>{t("RESIDENTS_SETTING.AUTO.DAYTIME")}</div>
                        <div className={`${htmlSwitch === "night" ? "title_typeB_stay" : "title_typeB"} fx-ccc on-mode w-6 h-75`} onClick={() => { setHtmlSwitch('night') }}>{t("RESIDENTS_SETTING.AUTO.NIGHT")}</div>
                        {/* 僅用來固定日間、夜間 width:20%，否則與上排按鈕選項會產生寬度不一致的落差 */}
                        <div className="title_typeB_hidden fx-ccc w-6 h-75"></div>
                        <div className="title_typeB_hidden fx-ccc w-6 h-75"></div>
                        <div className="title_typeB_hidden fx-ccc w-6 h-75"></div>
                    </div>
                    <div className="h-10 flied">
                        <div className="fx-ccc w-6 h-75 title_typeA">{t("RESIDENTS_SETTING.AUTO.TURN_LEFT_ANGLE")}</div>
                        <div className="fx-ccc w-12 h-75 content_input">
                            <div className="dropdown-container">
                                <REDropdown
                                    toggleDropdown={SwitchFunction}
                                    closeToggle={turnL_angSwitch}
                                    data={{ "id": 0, "keys": arrA, "data": turnL_ang }}
                                    returnData={setTurnL_ang}
                                />
                            </div>
                            <div className="content-unit">{t("GLOBAL.UNIT.DEGREE")}</div>
                        </div>
                        <div className="fx-ccc w-6 h-75 title_typeA">{t("RESIDENTS_SETTING.AUTO.TURN_LEFT_STAY")}</div>
                        <div className="fx-ccc w-12 h-75 content_input">
                            <div className="dropdown-container">
                                <REDropdown
                                    toggleDropdown={SwitchFunction}
                                    closeToggle={turnL_stySwitch}
                                    data={{ "id": 1, "keys": arrB, "data": turnL_sty }}
                                    returnData={setTurnL_sty}
                                />
                            </div>
                            <div className="content-unit">{t("GLOBAL.UNIT.MINUTE")}</div>
                        </div>
                    </div>
                    <div className="h-10 flied"></div>
                    <div className="h-10 flied">
                        <div className="fx-ccc w-6 h-75 title_typeA">{t("RESIDENTS_SETTING.AUTO.TURN_RIGHT_ANGLE")}</div>
                        <div className="fx-ccc w-12 h-75 content_input">
                            <div className="dropdown-container">
                                <REDropdown
                                    toggleDropdown={SwitchFunction}
                                    closeToggle={turnR_angSwitch}
                                    data={{ "id": 2, "keys": arrA, "data": turnR_ang }}
                                    returnData={setTurnR_ang}
                                />
                            </div>
                            <div className="content-unit">{t("GLOBAL.UNIT.DEGREE")}</div>
                        </div>
                        <div className="fx-ccc w-6 h-75 title_typeA">{t("RESIDENTS_SETTING.AUTO.TURN_RIGHT_STAY")}</div>
                        <div className="fx-ccc w-12 h-75 content_input">
                            <div className="dropdown-container">
                                <REDropdown
                                    toggleDropdown={SwitchFunction}
                                    closeToggle={turnR_stySwitch}
                                    data={{ "id": 3, "keys": arrB, "data": turnR_sty }}
                                    returnData={setTurnR_sty}
                                />
                            </div>
                            <div className="content-unit">{t("GLOBAL.UNIT.MINUTE")}</div>
                        </div>
                    </div>
                    <div className="h-10 flied"></div>
                    {htmlSwitch === "day"
                        ? Day_Html()
                        : Night_Html()
                    }

                    {/* 及時翻身控制 (暫時關閉) */}
                    {/* <div className="h-10 flied">
                        <div className="fx-ccc w-6 h-75 title_typeC rounded-pill">{t("RESIDENTS_SETTING.AUTO.REAL_TIME_CONTROL")}</div>
                        <button className="title_typeD fx-ccc on-mode w-6 h-75 rounded-pill" id="auto" onClick={()=>{btns_trigger(0)}}>{t("RESIDENTS_SETTING.AUTO.AUTO_TURN")}</button>
                        <button className="title_typeD fx-ccc on-mode w-6 h-75 rounded-pill" id="all_lock" onClick={()=>{btns_trigger(1)}}>{t("RESIDENTS_SETTING.AUTO.PANEL_LOCK")}</button>
                        <button className="title_typeD fx-ccc on-mode w-6 h-75 rounded-pill" id="lie_flat_and_lowest" onClick={()=>{btns_trigger(2)}}>{t("RESIDENTS_SETTING.AUTO.LIE_FLAT_AND_LOWEST")}</button>
                        <button className="title_typeD fx-ccc on-mode w-6 h-75 rounded-pill" id="lie_flat" onClick={()=>{btns_trigger(3)}}>{t("RESIDENTS_SETTING.AUTO.LIE_FLAT")}</button>
                        <button className="title_typeD fx-ccc on-mode w-6 h-75 rounded-pill" id="lowest" onClick={()=>{btns_trigger(4)}}>{t("RESIDENTS_SETTING.AUTO.LOWEST")}</button>
                    </div> */}
                </div>
            </div>

            <div className="wrap-auto-btn w-100 h-10">
                <div className="h-100 r-s-container">
                    <div className="h-100 flied">
                        <div className="fx-ccc w-100"></div>
                    </div>
                </div>
                <div className="h-100 l-s-container">
                    <div className="h-100 flied">
                        <div className="fx-ccc w-50 btn_type" onClick={postSubmit}>{t('GLOBAL.CONFIRM')}</div>
                        <div className="fx-ccc w-50 btn_type" onClick={props.hide}>{t('GLOBAL.CANCEL')}</div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default REAuto